import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import nav_brand from "../images/logo2.png"
import {useState} from "react";

export default function NavBarFunc() {

  const [showNav, setShowNav] = useState(false)

  return (
    <Navbar bg="dark" variant="dark" sticky="top">
      <Container>
        <Navbar.Brand href="/">
          <img
            src={nav_brand}
            width="30"
            height="30"
            className="d-inline-block align-top"
            alt="Element Data"
          /> {' '}
          Element Data
        </Navbar.Brand>

        <div className={`menu-container ${showNav ? "shown" : ""}`}>
          <ul className="menu">
            <li className="menu-item has-sub-menu">
              <a href="#">Informations</a>

              <ul className="sub-menu">
                <li className="menu-item">
                  <a href="/tokenomics">Tokenomics</a>
                </li>
                <li className="menu-item">
                  <a href="/rewards">Rewards</a>
                </li>
                <li className="menu-item">
                  <a href="/news">News</a>
                </li>
              </ul>
            </li>

            <li className="menu-item has-sub-menu">
              <a href="#">Instructions</a>

              <ul className="sub-menu">
                <li className="menu-item">
                  <a href="/configuration">Configuration/FAQ</a>
                </li>
                <li className="menu-item">
                  <a href="/download">Download</a>
                </li>
              </ul>
            </li>

            <li className="menu-item has-sub-menu">
              <a href="#">Air Data</a>

              <ul className="sub-menu">
                <li className="menu-item">
                  <a href="/data">Stats</a>
                </li>
                <li className="menu-item">
                  <a href="https://explorer.elementdata.xyz">Explorer</a>
                </li>
              </ul>
            </li>

            <li className="menu-item">
              <a href="/members">Account</a>
            </li>
          </ul>
        </div>

        <a href="#" onClick={function (e) {
          e.preventDefault();
          setShowNav(!showNav)
        }} className={`menu-toggle ${showNav ? "opened" : ""}`}><span></span></a>

      </Container>
    </Navbar>
  );
}
